import { render, staticRenderFns } from "./SendPostbackTemplate.vue?vue&type=template&id=6097d449&scoped=true&"
import script from "./SendPostbackTemplate.vue?vue&type=script&lang=js&"
export * from "./SendPostbackTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SendPostbackTemplate.vue?vue&type=style&index=0&id=6097d449&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6097d449",
  null
  
)

export default component.exports